/* ---------------- Utility: is a ref visible? ---------------- */
const isRefVisible = (ref) => {
  const el = ref?.current;
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  const style = window.getComputedStyle(el);
  return !(style.display === "none" || rect.width === 0 || rect.height === 0);
};

export default isRefVisible;
